import React, { useEffect, useState, ReactNode } from 'react';
import './index.css';

interface Props {
    expanded?: boolean,
    title?: ReactNode,
    titleRight?: ReactNode,
    onExpand?: Function,
    style?: React.CSSProperties
}

const HHExpand: React.FC<Props> = (props) => {
    const [expanded, setExpanded] = useState(props.expanded);

    useEffect(() => {
        setExpanded(props.expanded);
    }, [props.expanded])

    useEffect(() => {
        props.onExpand && expanded &&
            props.onExpand();
    }, [expanded])

    const existChildren = props.children!.toString().length > 0;

    return (
        <div className={`hh-expand${expanded ? ' expanded' : ''}`} style={props.style && props.style}>
            {
                props.title &&
                <div className={`header${(props.titleRight) ? " hover" : ""}`}>
                    <div className={`title${(existChildren) ? "" : " disabled"}`} onClick={(event: any) => { existChildren && setExpanded(!expanded) }}>
                        {
                            existChildren
                                ? <i className='ppi ppi-chevron-up' />
                                : <span style={{ marginLeft: '25px' }}>&nbsp;</span>
                        }
                        <span>{props.title}</span>
                    </div>
                    {
                        props.titleRight &&
                        <div className='functions'>{props.titleRight}</div>
                    }
                </div>
            }
            <div className={`body${expanded ? ' expanded' : ''}`}>
                <div className={`content`} style={{ marginLeft: (props.title) ? "28px" : "0" }}>
                    {props.children}
                </div>
            </div>
        </div>
    );
}

export default HHExpand;